var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"showName":false,"idKey":_vm.taskStage === 'archived' ? 'task_id' : 'id',"status-module":"parentTaskStatus","resource":_vm.resource}})
}
var staticRenderFns = []

export { render, staticRenderFns }